module.exports = __webpack_public_path__ + "img/menu_editor.15999c03.svg";